import React from "react"
import "../styles/Socials.css"


export default function Socials(){

return(<>
			<div id="Socials-Address">

			<div class='address'>

					<div class='line1'>56 redwood lane,Castleton Heights</div>
					<div class='line2'>Kingston 18, Calfornia,USA</div>

			</div>


			<div class='socials-imgs'>

					<img src='./images/fb.png' />
					<img src='./images/ig.png' />
					<img src='./images/whatsapp.png' />
					
			</div>



			</div>



		</>)

}